export const environment = {
  "production": false,
  "serviceWorker": false,
  "apiBaseUrl": "",
  "opsApiBaseUrl": "",
  "wsUrl": "",
  "sentryDsn": ""
};
